/**
 * Pack-style shelf: flavour tags + short titles on product cards.
 */
(function () {
  const FLAVOURS = [
    { key: 'sober', handle: 'the-sober-july-24-pack', re: /sober/i },
    { key: 'variety', handle: 'sidekick-variety-pack-12-pack-nz', re: /variety\s*pack|mixed\s+variety/i },
    { key: 'watermelon', handle: 'sidekick-watermelon-soda-12-pack', re: /watermelon/i },
    { key: 'cherry', re: /cherry/i },
    { key: 'pear', re: /pear/i },
    { key: 'strawberry', re: /strawberry/i },
    { key: 'mango', re: /mango/i },
  ];

  const mounted = new Set();

  function findTitleHeading(link) {
    if (!link) return null;
    return link.querySelector('h1, h2, h3, h4, h5, h6');
  }

  function isUsShowcase() {
    return !!(document.body && document.body.classList.contains('us-showcase'));
  }

  function cleanTitle(text, flavour) {
    if (!text) return text;
    if (flavour === 'sober') return 'Sober Pack';
    if (flavour === 'variety') return 'Variety';
    if (flavour === 'watermelon') return 'Watermelon';
    if (flavour === 'cherry') return 'Cherry';
    if (flavour === 'pear') return 'Pear';
    if (flavour === 'strawberry') return 'Strawberry';
    if (flavour === 'mango') return 'Mango';
    return text
      .replace(/^Sidekick\s+/i, '')
      .replace(/^Sodakick\s+/i, '')
      .replace(/\s+Soda\b.*$/i, '')
      .replace(/\s+(US|NZ|AU|UK|GB|CA)\s*$/i, '')
      .replace(/\s+\d+-Pack.*$/i, '')
      .trim();
  }

  function flavourLockupClass(flavour) {
    if (!flavour || flavour === 'sober') return '';
    if (flavour === 'strawberry' || flavour === 'watermelon') {
      return 'sk-flavour-name sk-flavour-name--long';
    }
    /* Variety uses Maxi uppercase like Cherry / Mango — not Narrow */
    return 'sk-flavour-name sk-flavour-name--short';
  }

  function applyFlavourLockup(heading, flavour) {
    if (!heading || !flavour || flavour === 'sober') return;
    heading.classList.remove('sk-flavour-name', 'sk-flavour-name--short', 'sk-flavour-name--long');
    flavourLockupClass(flavour).split(/\s+/).forEach(function (cls) {
      if (cls) heading.classList.add(cls);
    });
  }

  function getCardHandle(card) {
    const link = card.querySelector('a[ref="productCardLink"], a.product-card__link, a[href*="/products/"]');
    if (!link || !link.getAttribute('href')) return null;
    const match = String(link.getAttribute('href')).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function detectFlavour(title, card) {
    const handle = getCardHandle(card);
    for (let i = 0; i < FLAVOURS.length; i++) {
      if (FLAVOURS[i].handle && handle === FLAVOURS[i].handle) return FLAVOURS[i].key;
    }
    if (!title) return null;
    for (let j = 0; j < FLAVOURS.length; j++) {
      if (FLAVOURS[j].re && FLAVOURS[j].re.test(title)) return FLAVOURS[j].key;
    }
    return null;
  }

  function processCards(root) {
    if (!root) return;
    const cards = root.querySelectorAll('.product-card');
    cards.forEach((card) => {
      const link = card.querySelector('a[ref="productTitleLink"]');
      if (!link) return;
      const heading = findTitleHeading(link);
      const original = ((heading || link).textContent || '').trim();

      /* Prefer handle detection over a stale server class (variety used to
         ship as is-flavour-sober and skipped Bigticy). */
      const flavour = detectFlavour(original, card) || card.getAttribute('data-pack-flavour') || card.dataset.flavour;
      if (flavour) {
        ['sober', 'variety', 'watermelon', 'cherry', 'pear', 'strawberry', 'mango'].forEach(function (key) {
          card.classList.remove('is-flavour-' + key);
        });
        card.classList.add('is-flavour-' + flavour);
        card.dataset.flavour = flavour;
        card.setAttribute('data-pack-flavour', flavour);
      }
      card.dataset.flavourTagged = 'true';

      // Search results render the title as a text block, not a heading, so
      // there is nothing to shorten there — the flavour wash above still lands.
      if (!heading) return;

      const activeFlavour = card.dataset.flavour || flavour;
      if (link.dataset.titleCleaned !== 'true') {
        const cleaned = cleanTitle(original, activeFlavour);
        if (cleaned && cleaned !== original) {
          link.setAttribute('aria-label', original);
          heading.textContent = cleaned;
        }
        if (isUsShowcase() && cleaned) {
          var hidden = card.querySelector('.product-card__link .visually-hidden');
          if (hidden) hidden.textContent = cleaned;
          card.querySelectorAll('.product-grid-view-zoom-out--details h3, .product-grid-view-zoom-out--details .h4').forEach(function (h) {
            h.textContent = cleaned;
            applyFlavourLockup(h, activeFlavour);
          });
        }
        link.dataset.titleCleaned = 'true';
      }
      applyFlavourLockup(heading, activeFlavour);
    });
  }

  function mount(sectionId) {
    if (!sectionId || mounted.has(sectionId)) return;
    const root = document.getElementById(sectionId);
    if (!root) return;
    root.classList.add('pack-style-shelf');
    mounted.add(sectionId);
    processCards(root);
  }

  function mountAll() {
    document.querySelectorAll('[data-pack-style-shelf]').forEach((el) => {
      if (el.id) mount(el.id);
    });
  }

  window.PackStyleShelf = { mount, processCards, mountAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e?.target?.id) mount(e.target.id);
  });

  document.addEventListener('pack-style:update', (e) => {
    const root = e.target?.closest?.('[data-pack-style-shelf]') || e.target;
    if (root?.id) processCards(root);
    else mountAll();
  });
})();
